var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0646 5.51217H6.09753V6.99092H9.62378C9.44503 9.05468 7.72794 9.93759 6.10294 9.93759C4.02836 9.93759 2.20836 8.30176 2.20836 5.99967C2.20836 3.77884 3.94169 2.06176 6.10836 2.06176C7.78211 2.06176 8.76253 3.12884 8.76253 3.12884L9.79169 2.05634C9.79169 2.05634 8.47003 0.583008 6.05419 0.583008C2.97753 0.583008 0.599609 3.18301 0.599609 5.99967C0.599609 8.73509 2.83669 11.4163 6.13544 11.4163C9.03336 11.4163 11.1459 9.42842 11.1459 6.49259C11.1459 5.86967 11.0646 5.51217 11.0646 5.51217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.0e37a741a6469b5635c31eebbc28453c.svg";
export { ForwardRef as ReactComponent };